import React from 'react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import HeroSection from '../components/sections/HeroSection';
import FeaturesSection from '../components/sections/FeaturesSection';
import HowItWorksSection from '../components/sections/HowItWorksSection';
import TestimonialsSection from '../components/sections/TestimonialsSection';
import ScreenshotsSection from '../components/sections/ScreenshotsSection';
import DownloadSection from '../components/sections/DownloadSection';
import './HomePage.css';

function HomePage() {
  return (
    <div className="home">
      <Navbar />
      <main className="home__main">
        <HeroSection />
        <FeaturesSection />
        <HowItWorksSection />
        <ScreenshotsSection />
        <TestimonialsSection />
        <DownloadSection />
      </main>
      <Footer />
    </div>
  );
}

export default HomePage;